import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "A consulta é apenas para emagrecimento?",
    a: "Não. O acompanhamento também contempla composição corporal, hipertrofia, saúde metabólica, lipedema e prevenção.",
  },
  {
    q: "O atendimento é online?",
    a: "Sim. Atendo presencialmente em Mogi Guaçu e Artur Nogueira, e online para pacientes de todo o Brasil.",
  },
  {
    q: "A consulta inclui avaliação de exames?",
    a: "Sim. A análise dos exames faz parte do processo de avaliação individualizada.",
  },
  {
    q: "Vocês trabalham com Mounjaro?",
    a: "Quando indicado clinicamente, as opções terapêuticas são discutidas durante a consulta médica.",
  },
];

const FAQ = () => {
  return (
    <section
      id="faq"
      className="bg-[#FDFBF7] py-20 md:py-28"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-12 text-center"
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Dúvidas
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line-center"
            data-testid="faq-title"
          >
            Perguntas frequentes
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-[#EFEBE1] bg-white px-6"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 text-left font-serif text-base text-[#3E2723] hover:no-underline md:text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-[#4E342E]/85 md:text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
